import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "/static/alfont/font.css"

import request from './utils/request2.js'
Vue.prototype.$request = request

import request3 from './utils/request3.js'
Vue.prototype.$request3 = request3

import utils from './utils/utils.js'
Vue.prototype.utils = utils


// import TableAutoScroll from "table-auto-scroll";
// import "table-auto-scroll/dist/table-auto-scroll.css"; // 必须引入样式
// Vue.component("TableAutoScroll", TableAutoScroll);

import 'lib-flexible'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
Vue.config.productionTip = false

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')